import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { StateNames } from '../models/vendor.model';
import { VendorService } from '../shared/vendor.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from '../instructions/instructions.component';
import { ProgressBarService } from '../shared/progress-bar.service';

@Component({
  selector: 'app-witness-details',
  templateUrl: './witness-details.component.html',
  styleUrls: ['./witness-details.component.css', '../shared/css/common.css']
})
export class WitnessDetailsComponent implements OnInit {
  isformloaded: boolean = false;
  statelist: StateNames[] = [];
  primaryColor?: string = "";
  witnessForm = this.witnessFormBuilder.group({});
  witnessFormPart1 = this.witnessFormBuilder.group({});
  witnessFormPart2 = this.witnessFormBuilder.group({});
  witnessFormPart3 = this.witnessFormBuilder.group({});
  witnessFormPart4 = this.witnessFormBuilder.group({});

  constructor(
    private witnessFormBuilder: FormBuilder,
    private router: Router,
    private vendorService: VendorService,
    private cdref: ChangeDetectorRef,
    private modalService: NgbModal,
    private progressBarService: ProgressBarService) {
    this.formdata = JSON.parse(sessionStorage.getItem("activeformdata") || localStorage.getItem("activeformdata") || "{}");
    this.witnessFormDataPart1["controls"] = this.formdata.witnessDetails.controls.slice(0, 4);
    this.witnessFormDataPart2["controls"] = this.formdata.witnessDetails.controls.slice(4, 9);
    this.witnessFormDataPart3["controls"] = this.formdata.witnessDetails.controls.slice(9, 10);
    this.witnessFormDataPart4["controls"] = this.formdata.witnessDetails.controls.slice(10, 12);
    this.payorkey = parseInt(sessionStorage.getItem("payorkey") ?? "0");
  }

  witnessFormDataPart1: any = {};
  witnessFormDataPart2: any = {};
  witnessFormDataPart3: any = {};
  witnessFormDataPart4: any = {};
  payorkey: number;
  formdata: any | null;
  instructionText!: string | null;
  isInstruction: boolean = false;
  isFormsValid: boolean = false;
  referralParties: any = [];

  ngOnInit(): void {

    if (this.formdata) {
      this.vendorService.getRequiredFields(this.payorkey).subscribe((result) => {
        this.witnessFormDataPart1.controls.find((x: { name: string; }) => x.name == "trackingNumber").validators.required = result.ReferralInformationCaseReferenceTrackingNumber;
        this.witnessFormDataPart2.controls.find((x: { name: string; }) => x.name == "estimatedAmount").validators.required = result.ReferralInformationEstimatedMoneyInvolved;
        this.witnessFormDataPart2.controls.find((x: { name: string; }) => x.name == "originalDetectionDt").validators.required = result.ReferralInformationOriginalDetectionDate;
        this.witnessFormDataPart2.controls.find((x: { name: string; }) => x.name == "incidentStartDt").validators.required = result.ReferralInformationStartDate;
        this.witnessFormDataPart2.controls.find((x: { name: string; }) => x.name == "incidentEndDt").validators.required = result.ReferralInformationEndDate;
        this.witnessFormDataPart2.controls.find((x: { name: string; }) => x.name == "state").validators.required = result.ReferralInformationStateIncidentOccurred;
        this.witnessFormDataPart3.controls.find((x: { name: string; }) => x.name == "county").validators.required = result.ReferralInformationCountyIncidentOccurred;
        this.witnessFormDataPart3.controls.find((x: { name: string; }) => x.name == "county").disabled = true;

        this.isformloaded = true;
      });
      this.vendorService.getLeadHeaders(this.payorkey).subscribe((result) => {
        this.isInstruction = result.IsInstructionEnbaled;
        let instructionText = result.Instruction;
        instructionText = instructionText.replace('<img ', '<img title="Header" ')
        this.instructionText = instructionText;
        this.cdref.detectChanges(); 
      });
      setTimeout(() => {
        if (localStorage.getItem('primaryCssColor') != null && typeof (localStorage.getItem('primaryCssColor')) != 'undefined') {
          const colorFromStorage = localStorage.getItem('primaryCssColor');
          this.primaryColor = colorFromStorage ? colorFromStorage.toString() : '';
          document.documentElement.style.setProperty('--primary-color', this.primaryColor);
        }
      }, 0);
      this.cdref.detectChanges();
      const selectedPartyId = this.witnessFormDataPart1.controls.find( (x: { name: string }) => x.name == "involvedType" )?.value;

        if (selectedPartyId) {
          this.vendorService.getInvolvedPartyById(selectedPartyId, this.payorkey).subscribe((party) => {
            sessionStorage.setItem("selectedProfileMasterTypeKey", party.ProfileMasterTypeKey?.toString() ?? "");
            this.formdata.selectedProfileMasterTypeKey = party.ProfileMasterTypeKey;
            this.vendorService.updateData(this.formdata);
          });
        }

      this.vendorService.getReferralTypesLookup(this.payorkey).subscribe((result) => {
        this.referralParties = result;
        this.witnessFormDataPart1.controls.find((x: { name: string; }) => x.name == "referalType").options = result.map(x => { return { "value": x.Id, "key": x.Title } });
        setTimeout(() => {
          const referalTypeValue = this.witnessFormDataPart1.controls.find((x: { name: string; }) => x.name == "referalType").value;
          if (referalTypeValue) {
            (this.witnessFormPart1.get('referalType') as any)?.setValue(referalTypeValue);
          }
        }, 10);
      });

      this.vendorService.getStateNames().subscribe((result) => {

        this.statelist = result;
        this.witnessFormDataPart2.controls.find((x: { name: string; }) => x.name == "state").options = this.statelist.map(x => { return { "value": x.Abbreviation, "key": x.Name } });
        setTimeout(() => {
          const referalTypeValue = this.witnessFormDataPart2.controls.find((x: { name: string; }) => x.name == "state").value;
          if (referalTypeValue) {
            (this.witnessFormPart2.get('state') as any)?.setValue(referalTypeValue);
          }
        }, 10);
      })
      if (!this.witnessFormDataPart1.controls.find((x: { name: string; }) => x.name == "involvedType").value) {
        this.vendorService.getInvolvedPartiesLookup(this.payorkey).subscribe((result) => {

          this.witnessFormDataPart1.controls.find((x: { name: string; }) => x.name == "involvedType").options = result.map(x => { return { "value": x.Id, "key": x.Title } });
          setTimeout(() => {
            const involvedTypeValue = this.witnessFormDataPart1.controls.find((x: { name: string; }) => x.name == "involvedType").value;
            if (involvedTypeValue) {
              (this.witnessFormPart1.get('involvedType') as any)?.setValue(involvedTypeValue);
            }
          }, 10);
        })
      }
    }
    
    setTimeout(() => {
      this.progressBarService.sendData(true);
    });
  }

  valueChangeEvent(e: any) {
    if (e.name == 'state') {
      this.vendorService.getStateCounties(this.statelist.find(y => y.Id == e.value.target.selectedIndex)?.Abbreviation ?? "").subscribe((result) => {
        this.witnessFormDataPart3.controls.find((x: { name: string; }) => x.name == "county").options = result.map(x => { return { "value": x.County, "key": x.County } });
      })
      this.witnessFormDataPart3.controls.find((x: { name: string; }) => x.name == "county").disabled = false;
    }
    if (e.name == 'estimatedAmount') {
      const cleanVal = typeof e.value === 'string' ? e.value.replace(/[^0-9.]+/g, '') : e.value;
      this.witnessFormDataPart2.controls.find((x: { name: string; }) => x.name == e.name).value = cleanVal;
    }
    if (e.name == 'referalType') {
      var referralTypeId = parseInt(this.witnessFormDataPart1.controls.find((x: { name: string; }) => x.name == "referalType").value);
      var getLeadReason = this.referralParties.filter((a: any) => { return (a.Id == referralTypeId) });
      this.witnessFormDataPart4.controls.find((x: { name: string; }) => x.name == "associatedLeadReasonId").value = getLeadReason[0]?.AssociatedLeadReasonId;
    }
    if(e.name == 'incidentStartDt' || e.name == 'incidentEndDt' || e.name == 'originalDetectionDt'){
      this.dateValidation();
    }
    if (e.name == 'involvedType') {
      const selectedPartyId = parseInt(this.witnessFormDataPart1.controls.find((x: { name: string; }) => x.name == "involvedType").value);

      this.vendorService.getInvolvedPartyById(selectedPartyId, this.payorkey).subscribe((party) => {
        sessionStorage.setItem("selectedProfileMasterTypeKey", party.ProfileMasterTypeKey?.toString() ?? "");
        this.formdata.selectedProfileMasterTypeKey = party.ProfileMasterTypeKey;
        this.vendorService.updateData(this.formdata);
      });
    }
    this.formValidate(e);
  }

  referralDetailsSubmit() {
    if (this.witnessFormPart1.valid && this.witnessFormPart2.valid && this.witnessFormPart3.valid && this.witnessFormPart4.valid) {
      var tempArr = { controls: [] };
      tempArr.controls = this.witnessFormDataPart1.controls
        .concat(this.witnessFormDataPart2.controls, this.witnessFormDataPart3.controls, this.witnessFormDataPart4.controls);

      this.formdata.witnessDetails = tempArr;

      const selectedPartyId = this.witnessFormDataPart1.controls.find(
        (x: { name: string }) => x.name == "involvedType"
      )?.value;

      if (selectedPartyId) {
        this.vendorService.getInvolvedPartyById(selectedPartyId, this.payorkey).subscribe((party) => {

          const key = party?.ProfileMasterTypeKey ?? party?.ProfileMasterTypeKey;
          sessionStorage.setItem("selectedProfileMasterTypeKey", key?.toString() ?? "");
          this.formdata.selectedProfileMasterTypeKey = key;
          this.vendorService.updateData(this.formdata);
          this.router.navigate(['involvedParties']);
        });
      } else {
        this.vendorService.updateData(this.formdata);
        this.router.navigate(['involvedParties']);
      }
    }
    
    if(this.isFormsValid) {
      window.sessionStorage.setItem("ReferralFormValid", "true");
    }
    else {
      window.sessionStorage.removeItem("ReferralFormValid");
    }
  }

  back() {
    var tempArr = { controls: [] }
    tempArr.controls = this.witnessFormDataPart1.controls
      .concat(this.witnessFormDataPart2.controls, this.witnessFormDataPart3.controls, this.witnessFormDataPart4.controls);

    this.formdata.witnessDetails = tempArr;
    this.vendorService.updateData(this.formdata);
    sessionStorage.setItem('returningFromWitness', 'true');

    const profileKey = sessionStorage.getItem("selectedProfileMasterTypeKey");

    if (profileKey === "2") {
      this.router.navigate([sessionStorage.getItem("securityCode")]);
    } else {
      this.router.navigate([sessionStorage.getItem("securityCode")]);
    }
    
    if(this.isFormsValid) {
      window.sessionStorage.setItem("ReferralFormValid", "true");
    }
    else {
      window.sessionStorage.removeItem("ReferralFormValid");
    }

    setTimeout(() => {
      this.progressBarService.sendData(true);
    });
  }


  openInstruction() {

    const result = this.modalService.open(InstructionsComponent, { size: 'lg', ariaLabelledBy: 'Instructions' });
    result.componentInstance.name = this.instructionText;
  }

  formValidate(data: any) {
    const newValidState = this.witnessFormPart1.valid && this.witnessFormPart2.valid && this.witnessFormPart3.valid && this.witnessFormPart4.valid && this.dateValidation();
    
    if (this.isFormsValid !== newValidState) {
      setTimeout(() => {
        this.isFormsValid = newValidState;
        if(this.isFormsValid) {
          window.sessionStorage.setItem("ReferralFormValid", "true");
        }
        else {
          window.sessionStorage.removeItem("ReferralFormValid");
        }
      });
    }
  }

  dateValidation() : boolean {
    let result = true;
    
    const today = new Date();
    today.setHours(0, 0, 0, 0); 

    const fromDate = this.witnessFormDataPart2.controls.find((x: { name: string; }) => x.name == "incidentStartDt").value ? new Date(this.witnessFormDataPart2.controls.find((x: { name: string; }) => x.name == "incidentStartDt").value) : null;
    const toDate = this.witnessFormDataPart2.controls.find((x: { name: string; }) => x.name == "incidentEndDt").value ? new Date(this.witnessFormDataPart2.controls.find((x: { name: string; }) => x.name == "incidentEndDt").value) : null;
    const originalDetectionDt = this.witnessFormDataPart2.controls.find((x: { name: string; }) => x.name == "originalDetectionDt").value ? new Date(this.witnessFormDataPart2.controls.find((x: { name: string; }) => x.name == "originalDetectionDt").value) : null;

    let toDateError = '';
    let fromDateError = '';
    let originalDetectionDtError = '';

    if (originalDetectionDt && originalDetectionDt > today) {
      originalDetectionDtError = 'Date cannot be in the future.';
    }

    if ((fromDate && fromDate > today) || (toDate && toDate > today)) {
      if (fromDate && fromDate > today) {
      fromDateError = 'Date cannot be in the future or Incident End Date cannot be prior to the Incident Start Date.';
    }
     if (toDate && toDate > today) {
      toDateError = 'Date cannot be in the future or Incident End Date cannot be prior to the Incident Start Date.';
    }
  }
    else if (toDate && !fromDate) {
      toDateError = 'Date cannot be in the future or Incident End Date cannot be prior to the Incident Start Date.';
    } else if (toDate && fromDate && toDate < fromDate) {
      toDateError = 'Date cannot be in the future or Incident End Date cannot be prior to the Incident Start Date.';
    } else {
      toDateError = '';
      fromDateError ='';
    }

    if (fromDateError != '') {
      var errorElement = document.getElementById('incidentStartDt_Error');
      if (errorElement) {
        errorElement.textContent = fromDateError;
        result = false;
      }
    }else{
      var errorElement = document.getElementById('incidentStartDt_Error');
      if (errorElement) {
        errorElement.textContent = '';
      }
    }

    if (toDateError != '') {
      var errorElement = document.getElementById('incidentEndDt_Error');
      if (errorElement) {
        errorElement.textContent = toDateError;
        result = false;
      }
    }else{
      var errorElement = document.getElementById('incidentEndDt_Error');
      if (errorElement) {
        errorElement.textContent = toDateError;
      }
    }

    if (originalDetectionDtError != '') {
      var errorElement = document.getElementById('originalDetectionDt_Error');
      if (errorElement) {
        errorElement.textContent = originalDetectionDtError;
        result = false;
      }
    }else{
      var errorElement = document.getElementById('originalDetectionDt_Error');
      if (errorElement) {
        errorElement.textContent = '';
      }
    }

    if(fromDateError == '' && toDateError == '' && originalDetectionDtError == '')
    {
      result = true;
    }
    else
    {
      result = false;
    }

    return result;
  }

}
